import graphemeSplitter from "grapheme-splitter";

const splitter = new graphemeSplitter();

export class PersistObject<Shape> {
    private _value: Shape;
    constructor(private _key: string, defaultValue: Shape, storeDefault = false) {
        let value = defaultValue;
        try {
            value = JSON.parse(localStorage[this._key]);
        } catch (e) {}
        this._value = value !== undefined ? value : defaultValue;
        if (storeDefault) {
            try {
                window.localStorage[this._key] = JSON.stringify(this._value);
            } catch (e) {}
        }
    }
    get value() {
        return this._value;
    }
    set value(value: Shape) {
        try {
            window.localStorage[this._key] = JSON.stringify(value);
        } catch (e) {}
        this._value = value;
    }
    public clean() {
        try {
            window.localStorage.removeItem(this._key);
        } catch (e) {}
    }
}

export function cycleOverList<T>(elements: T[], currentElement: T, direction: "prev" | "next") {
    if (elements.length > 1) {
        let index = elements.indexOf(currentElement);
        if (index !== -1) {
            const lastElement = elements.length - 1;
            index = index + (direction === "prev" ? -1 : 1);
            index = 0 <= index ? (index <= lastElement ? index : 0) : lastElement;
            return elements[index];
        }
    }
    return null;
}

export function splitGraphemes(input: string) {
    return splitter.splitGraphemes(input);
}
